import {onFind,} from "@elements/init-modules-in-scope";

import Collapse from 'bootstrap.native/dist/components/collapse-native.esm';
onFind('[data-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import './scripts/common';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as affix from '@elements/affix';
app.affix = affix.init();

import * as lightbox from '@elements/lightbox';
app.lightbox = lightbox.init();

import * as scrollingArea from './scripts/scrolling-area';
scrollingArea.init();

import * as formValidation from './scripts/form-validation';
formValidation.init();

import * as friendlyCaptcha from './scripts/friendly-captcha';
friendlyCaptcha.init();

import * as actionChanger from '@elements/action-changer';
app.actionChanger = actionChanger.init();

//renderTemplate
import * as roomPlan from './scripts/3d-room-plan';
roomPlan.init();